// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBellCheck, iconBellCheckTag } from '@ni/nimble-components/dist/esm/icons/bell-check';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBellCheck };
export { iconBellCheckTag };
export const NimbleIconBellCheck = wrap(IconBellCheck);